// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPointMapOutlinedSvg from "@fishx/icons-svg/es/asn/PPointMapOutlined";
import FishxIcon from '../components/FishxIcon';

var PPointMapOutlined = function PPointMapOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPointMapOutlinedSvg
  }));
};

PPointMapOutlined.displayName = 'PPointMapOutlined';
export default React.forwardRef(PPointMapOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPointMapOutlined.js
// module id = 3552
// module chunks = 0